import React from 'react';
import PropTypes from 'prop-types';

const LastUpdated = ({ date }) => {
    return (
        <div className="fact -inline -dark">
            <span className="meta -fact fact__meta">Last Updated</span>
            <span className="fact__stat">{date}</span>
        </div>
    );
};

LastUpdated.propTypes = {
    date: PropTypes.string,
};

export default LastUpdated;
